// extracted by mini-css-extract-plugin
module.exports = {"walletButton":"WalletButton_walletButton__Q_aK0"};